/**
 * After a partner clicks a GoSnel AI deep link, show a quick way back to the same chat.
 */
import { Button } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { useLocation, useNavigate } from 'react-router-dom';

export default function LpAiReturnChip() {
  const location = useLocation();
  const navigate = useNavigate();
  const fromAi = Boolean(location.state?.fromGosnelAi);
  if (!fromAi) return null;

  const conversationId = location.state?.conversationId;
  if (conversationId) {
    try {
      localStorage.setItem('lp_gosnel_ai_conversation_id', conversationId);
    } catch {
      /* ignore */
    }
  }

  return (
    <Button
      variant="contained"
      size="small"
      startIcon={<AutoAwesomeIcon />}
      onClick={() => navigate('/ai')}
      sx={{
        position: 'fixed',
        left: { xs: 12, sm: 24 },
        bottom: { xs: 16, sm: 24 },
        zIndex: 1390,
        textTransform: 'none',
        fontWeight: 800,
        bgcolor: '#0f766e',
        borderRadius: 999,
        px: 1.75,
        boxShadow: '0 8px 24px rgba(15,118,110,0.35)',
        '&:hover': { bgcolor: '#0d9488' },
      }}
    >
      Continue GoSnel AI
    </Button>
  );
}
